import clsx from 'clsx';
import React from 'react';

import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';
import LazyImgixImage from '@components/LazyImgixImage';
import { getArticleImgSrc } from '@utils/images';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import PictureCaption from '../PictureCaption';
import { ThemeViewsProps } from '../interfaces';
import styles from '../styles.module.scss';
import Content from './Content';

const Feature = ({
  article: {
    addendum,
    authors,
    commentCount,
    commenters,
    freeBlurb,
    fullText,
    highlight,
    id,
    isPro,
    pickups,
    picture,
    pictureCaption,
    publishedAt,
    subTitle,
    takeaway,
    title,
  },
  canViewFullArticle,
  clipperProps,
  env,
  isSEOBot,
  mostPopularArticles,
  newsletter,
  relatedArticles,
  shareLink,
  subscriberCouncil,
}: ThemeViewsProps) => {
  return (
    <>
      <figure className="relative m-auto h-[calc(100vw*(9/16))]" aria-labelledby="caption-text">
        {isPro && <IconProTagArticle className="absolute right-0 top-0 w-[65px] sm:w-[119px]" />}
        <LazyImgixImage
          alt={title}
          className="article-hero-image h-auto w-full"
          src={getArticleImgSrc(id, picture, env)}
          wrapperClassName="w-full h-full"
        />
      </figure>
      <div className="px-16 sm:px-28">
        <div className="relative m-auto lg:max-w-[1060px] xl:max-w-container-lg">
          <div
            className={clsx(
              styles.headerContainer,
              'absolute -left-36 -top-[92px] hidden h-[200px] bg-white lg:block lg:w-[844px] xl:w-[1012px]'
            )}
          />
          <div className="flex flex-col-reverse lg:flex-row lg:gap-72 xl:gap-112">
            <div className="z-10 flex-1 pt-28 sm:pt-48 lg:-mt-[92px] lg:pt-24">
              <Header highlight={highlight} title={title} subTitle={subTitle} />
              <div className="mb-40 mt-32 sm:mb-48 sm:mt-48 md:mb-64">
                <ArticleDetails
                  authors={authors}
                  commentCount={commentCount}
                  commenters={commenters}
                  publishedAt={publishedAt}
                  shareLink={shareLink}
                />
              </div>
            </div>
            <PictureCaption pictureCaption={pictureCaption} />
          </div>
          <Content
            addendum={addendum}
            authors={authors}
            bodyClassName={styles.isFeature}
            canViewFullArticle={canViewFullArticle}
            clipperProps={clipperProps}
            commentCount={commentCount}
            env={env}
            freeBlurb={freeBlurb}
            fullText={fullText}
            id={id}
            isSEOBot={isSEOBot}
            mostPopularArticles={mostPopularArticles}
            newsletter={newsletter}
            pickups={pickups}
            relatedArticles={relatedArticles}
            subscriberCouncil={subscriberCouncil}
            takeaway={takeaway}
          />
        </div>
      </div>
    </>
  );
};

export default Feature;
